var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{ show: _vm.showSnackbar },style:({ 'background-color': _vm.snackbarColor }),attrs:{"id":"snackbar"}},[_vm._v(" "+_vm._s(_vm.snackbarMessage)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }